import { lazy, Suspense, useState } from 'react';

import type { Koordinat } from '../api/gorev';

/**
 * HARİTADAN NOKTA SEÇME.
 *
 * NOKTA, POLİGON DEĞİL. Görev bölgesi sınırı (`gorev_bolgesi.sinir`) Faz 2'de;
 * o bir MultiPolygon ve şef başına 20-30 çizim demek. Bu ise tek tık ve hiçbir
 * kurala girmiyor — yalnız "bu iş nerede" sorusunu cevaplıyor.
 *
 * HARİTA TEMBEL YÜKLENİR. Leaflet ~150 kB; dört sekmeden yalnız ikisinde
 * kullanılıyor ve ana pakete girseydi her açılışta indirilirdi.
 *
 * DÖŞEME ADRESİ ORTAM DEĞİŞKENİYLE (`VITE_HARITA_DOSEME`). Döşeme istekleri
 * ÜÇÜNCÜ TARAFA gider ve görevin yaklaşık konumunu sızdırır; belediyenin kendi
 * ya da il sunucusuna çevirebilmesi KVKK açısından gerekli. Sabit yazılsaydı
 * bu seçenek hiç olmazdı.
 */

const Harita = lazy(() => import('./HaritaTuvali'));

export function HaritaNoktasi({
  deger,
  degisti,
  etiket = 'Konum',
}: {
  deger: Koordinat | null;
  degisti: (yeni: Koordinat | null) => void;
  etiket?: string;
}) {
  const [acik, acikYaz] = useState(false);

  return (
    <div>
      <span className="mb-1 block text-sm font-medium text-slate-700">{etiket}</span>

      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-slate-600">
          {deger === null ? (
            'Seçilmedi'
          ) : (
            /* Altı basamak ≈ 10 cm; daha fazlası sahte hassasiyet olurdu. */
            <code className="text-xs">
              {deger.enlem.toFixed(6)}, {deger.boylam.toFixed(6)}
            </code>
          )}
        </span>

        <button
          type="button"
          onClick={() => acikYaz((o) => !o)}
          className="rounded px-2 py-1 text-xs text-kurum-700 hover:bg-kurum-50"
        >
          {acik ? 'Haritayı gizle' : 'Haritadan seç'}
        </button>

        {deger !== null && (
          <button
            type="button"
            onClick={() => degisti(null)}
            className="rounded px-2 py-1 text-xs text-slate-600 hover:bg-slate-100"
          >
            Temizle
          </button>
        )}
      </div>

      {acik && (
        <div className="mt-2 h-64 overflow-hidden rounded-md border border-slate-200">
          <Suspense
            fallback={
              <p className="flex h-full items-center justify-center text-sm text-slate-500">
                Harita yükleniyor…
              </p>
            }
          >
            <Harita deger={deger} degisti={degisti} />
          </Suspense>
        </div>
      )}

      <span className="mt-1 block text-xs text-slate-500">
        İsteğe bağlı. Hiçbir kurala girmez; PWA “yol tarifi al” için kullanır.
      </span>
    </div>
  );
}
